import { Component, OnInit } from "@angular/core";
import { AuthService } from "src/app/shared/services/auth/auth.service";
import { ClubsponsorshipService } from 'src/app/shared/services/clubsponsorship.service';
import { NgForm, FormsModule } from "@angular/forms";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import * as moment from "moment";
declare var jQuery: any;
declare const bolt: any;

@Component({
  selector: "app-clubsponsorshipcheckout",
  templateUrl: "./clubsponsorshipcheckout.component.html",
  styleUrls: ["./clubsponsorshipcheckout.component.scss"],
})
export class ClubsponsorshipcheckoutComponent implements OnInit {
  is_authenticate_user: boolean = false;
  clubsponsorList: any = "";
  clubRequest: any = {};
  clubSingle: any = {};

  promocodeRequest: any = {};

  slected_address = 0;
  slected_card = 0;
  cus_id = 0;
  ordercart: any = "";
  ordercartlist = 0;
  orderRequest: any = {};
  orderError: any;
  orderSuccess: any;

  addressError: any;
  cardloadError: any;

  checkoutRequest: any = {};
  checkoutError: any;
  checkoutSuccess: any;
  checkoutsocError: any;
  checkoutsocSuccess: any;

  cardRequest: any = {};
  cardError: any;
  cardSuccess: any;
  cardsocError: any;
  cardsocSuccess: any;

  assignRequest: any = {};
  assignError: any;
  assignSuccess: any;
  assignsocError: any;
  assignsocSuccess: any;
  cartList: any = "";
  orderbookinList: any = "";
  assignList: any = "";
  addressList: any = "";
  cardList: any = "";
  grandTotal: any = 0;
  subTotal: any = 0;
  request: any = {};
  today = new Date();
  user: any = "";
  totalqty: any = 1;
  public min: Date = new Date(1900, 1, 1, 12, 30);

  discount_amount: any = 0;
  finalPrice: any = 0;

  constructor(
    public authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public clubService: ClubsponsorshipService,
  ) {}

  ngOnInit() {
    jQuery(".checkout-center-detail-code-voucher").click(function () {
      jQuery(".checkout-center-detail-code").addClass("intro");
      jQuery(".checkout-center-detail-full").addClass("intro");
      //return false;
    });
   
      /*this.authService.getClubsponsor().then((data) => {
	      this.clubsponsorList = data;
	      console.log(this.clubsponsorList);
	    });*/
      this.activatedRoute.params.subscribe((data) => {
        if (data.slug) {
          this.getClubsponsor(data.slug);
          //this.clubRequest = data.slug;
        }
      });
   

    this.loadaddress();
    this.loadcard();

    this.checkoutRequest = {
      phone_code: 91,
      latitude: 23.123456,
      longitude: 72.123456,
    };

    this.assignRequest = {
      matchticket_assign_id: jQuery("#matchticket_assign_id").val(),
    };
    this.authService.$user.subscribe((data) => {
      console.log("login chhhhe");
      console.log(data);
      if (data) {
        //console.log("login chhhhe j");
        //console.log(data);
        this.user = data;
        //console.log(this.user.appuser_id);
        //this.checkautoLogin();
        //this.checkcart();
        //this.checkshopcart();
        (this.clubRequest.auth_key = this.user.auth_key),
          (this.clubRequest = {
            auth_key: this.user.auth_key,
          });
        this.cardRequest = {
          auth_key: this.user.auth_key,
        };
      } else {
        this.user = null;
        //console.log("login nathi");
      }
    });
  }

  getClubsponsor(clubslug) {
    //this.clubRequest.club_sponsor_id = clubslug;
    //let request = Object.assign({}, this.clubRequest)
    this.clubService.getClubsponsordetail(clubslug).then((data) => {
      this.clubSingle = data.data || {};

      console.log(this.clubSingle);
      console.log(jQuery("#quantity").val());
      this.subTotal =
        parseInt(jQuery("#quantity").val()) * parseInt(data.data.amount);

      console.log(this.subTotal);
      setTimeout(function () {
        jQuery("#minus_btn").click(function () {
          var qtyval = jQuery("#quantity").val();
          if (qtyval > 1) {
            qtyval = parseInt(qtyval) - 1;
            jQuery("#quantity").val(qtyval);
          }
        });
        jQuery("#plus_btn").click(function () {
          var qtyval = jQuery("#quantity").val();
          qtyval = parseInt(qtyval) + 1;
          jQuery("#quantity").val(qtyval);
        });

        jQuery(".increment-quantity").click((e) => {
          var dataid = e.currentTarget.id;
          console.log(dataid);
          var qtyval = jQuery("#quantity").val();
          var prival = jQuery("#price").val();

          qtyval = parseInt(qtyval) + 1;
          this.totalqty = qtyval;
          this.subTotal = qtyval * prival;
          console.log("hello");
          console.log(this.subTotal);
        });
        jQuery(".decrement-quantity").click(function () {
          var dataid = jQuery(this).attr("id");
          var qtyval = jQuery("#quantity").val();
          var prival = jQuery("#price").val();
          if (qtyval > 1) {
            qtyval = parseInt(qtyval) - 1;
            this.totalqty = qtyval;
            jQuery("#quantity").val(qtyval);
            this.generaladAdultCount = qtyval;
            this.generaladAdult = jQuery("#pNos").html(qtyval + " Nos.");
            this.generaladAdultvalue = jQuery("#pPrice").html(
              "£" + qtyval * prival + ".00"
            );
            this.generaladAdultvalue = jQuery("#gPrice").html(
              "£" + qtyval * prival + ".00"
            );
          }
        });
      }, 1000);
    });
  }
  incrementqty() {
    var qtyval = jQuery("#quantity").val();
    var prival = jQuery("#price").val();
    qtyval = parseInt(qtyval) + 1;
    jQuery("#quantity").val(qtyval);
    this.totalqty = qtyval;
    this.subTotal = qtyval * prival;
  }
  decrementqty() {
    var qtyval = jQuery("#quantity").val();
    var prival = jQuery("#price").val();
    qtyval = parseInt(qtyval) - 1;
    jQuery("#quantity").val(qtyval);
    this.totalqty = qtyval;
    this.subTotal = qtyval * prival;
  }
  addAddress(form: NgForm) {
    if (form.valid) {
      //console.log(this.checkoutRequest.email);

      let request: any = {};
      request = Object.assign({}, this.checkoutRequest);
      //console.log(request);
      this.authService
        .userAddress(request)
        .then((res) => {
          //console.log(res.status);

          if (res.status == 0) {
            this.checkoutError = res.message;
          } else {
            jQuery(".checkout-center-detail-address").removeClass("show-form");
            jQuery(".checkout-center-detail-address").addClass("hide-form");
            this.authService.getuserAddress().then((res) => {
              this.addressList = res.data;
            });
          }
        })
        .catch((err) => {
          this.checkoutError = err;
        });
    }
  }

  addCard(form: NgForm) {
    if(this.authService.isLoggedIn == true)
    {
       this.is_authenticate_user = true;
    if (form.valid) {
      //console.log(this.checkoutRequest.email);

      let request: any = {};
      request = Object.assign({}, this.cardRequest);
      //console.log(request);
      this.authService
        .addCard(request)
        .then((res) => {
          //console.log(res.status);

          if (res.status == 0) {
            this.cardError = res.message;
          } else {
            jQuery(".ashton-hero-top-payment-add-card-detail").removeClass(
              "show-form"
            );
            jQuery(".ashton-hero-top-payment-add-card-detail").addClass(
              "hide-form"
            );
            this.loadcard();
          }
        })
        .catch((err) => {
          this.checkoutError = err;
        });
    }
  }else{
    this.router.navigate(['/singin']);
   }

  }

  updateAssign(form: NgForm, assignid: any) {
    if (form.valid) {
      this.assignRequest.matchticket_assign_id = jQuery(
        "#matchticket_assign_id-" + assignid
      ).val();

      //console.log(this.assignRequest.matchticket_assign_id);

      let request: any = {};
      request = Object.assign({}, this.assignRequest);
      //console.log(request);
      this.authService
        .updateAssign(request)
        .then((res) => {
          //console.log(res.message);
          if (res.status == 0) {
            this.assignError = res.message;
          } else {
            jQuery.magnificPopup.close();
          }
        })
        .catch((err) => {
          this.assignError = err.error.message;
        });
    }
  }

  loadaddress() {
    this.authService
      .getuserAddress()
      .then((res) => {
        if (res.status == 0) {
          this.addressError = "No address added yet";

          jQuery(".checkout-center-detail-address").removeClass("hide-form");
          jQuery(".checkout-center-detail-address").addClass("show-form");
        } else {
          //console.log(res);
          this.addressList = res.data;
          console.log(this.addressList);
          // jQuery(".checkout-center-detail-address-content-box").removeClass("hide-form");
          //jQuery(".checkout-center-detail-address-content-box").addClass("show-form");
        }
      })
      .catch((err) => {
        //console.log(err);
      });
  }

  loadcard() {
    this.authService
      .getcardlist()
      .then((res) => {
        if (res.status == 0) {
          this.cardloadError = "No Cards added yet";

          jQuery(".ashton-hero-top-payment-add-card-detail").removeClass(
            "hide-form"
          );
          jQuery(".ashton-hero-top-payment-add-card-detail").addClass(
            "show-form"
          );
        } else {
          //console.log(res);
          this.cardList = res.data;
          console.log(this.cardList);
          // jQuery(".checkout-center-detail-address-content-box").removeClass("hide-form");
          //jQuery(".checkout-center-detail-address-content-box").addClass("show-form");
        }
      })
      .catch((err) => {
        //console.log(err);
      });
  }

  selectaddress(aid: any) {
    console.log(aid);
    this.slected_address = aid;
  }

  selectcard(cid: any, cuid: any) {
    console.log(cid);
    console.log(cuid);
    this.slected_card = cid;
    this.cus_id = cuid;
  }
  apply_vourcher() {
    if (jQuery(".course-final-apply-voucher-box").hasClass("active")) {
      if (jQuery("#promo_code").val() != "" && this.subTotal != "") {
        this.promocodeRequest = {
          code: jQuery("#promo_code").val(),
          type: "Club Sponsorship",
          total: this.subTotal,
        };
        let request: any = {};
        request = Object.assign({}, this.promocodeRequest);
        this.authService.applayPromocode(request).then((data) => {
          console.log(data);
          if (data["status"] == 0) {
            jQuery(".apply_message").html(data["message"]);
            jQuery(".apply_message").addClass("fail").removeClass("success");
            jQuery(".course-final-apply-voucher-box")
              .addClass("fail")
              .removeClass("success");
            return false;
          } else {
            if (parseInt(data["data"].discount) <= parseInt(this.subTotal)) {
              this.discount_amount = data["data"].discount;
              this.grandTotal =
                parseInt(this.subTotal) - parseFloat(this.discount_amount);
              console.log(this.grandTotal);
              /* this.generateorderId(this.finalPrice);
                  if(this.finalPrice == 0){
                    this.make_a_payment = 0;
                  } */
              jQuery(".apply_message").html("Promo code applied");
              jQuery(".apply_message").addClass("success").removeClass("fail");
              jQuery(".course-final-apply-voucher-box")
                .addClass("success")
                .removeClass("fail");
            } else {
              jQuery(".apply_message").html("Discount amount is invalid");
              jQuery(".apply_message").addClass("fail").removeClass("success");
              jQuery(".course-final-apply-voucher-box")
                .addClass("fail")
                .removeClass("success");
            }
          }
        }).catch((err) => {
          //jQuery(alert('error'));
          jQuery(".apply_message").html(err.error["message"]);
          jQuery(".apply_message").addClass("fail").removeClass("success");
          jQuery(".course-final-apply-voucher-box")
            .addClass("fail")
            .removeClass("success");
          return false;
          //console.log({ err });
          //this.loginError = err;
    });
      } else {
        jQuery(".apply_message").html("Please enter promo code");
        jQuery(".apply_message").addClass("fail").removeClass("success");
        jQuery(".course-final-apply-voucher-box")
          .removeClass("fail")
          .removeClass("success");
        return false;
      }
    } else {
      jQuery(".course-final-apply-voucher-box").addClass("active");
      jQuery(".course-final-detail-right-center-detail").addClass("open");
    }
  }
  clearcode() {
    jQuery("#promo_code").val("");
    jQuery("#promo_code").focus();
    jQuery(".course-final-apply-voucher-box")
      .removeClass("fail")
      .removeClass("success");
    jQuery(".apply_message").html("");
    jQuery(".apply_message").removeClass("fail").removeClass("success");
  }

  confirm_pay() {
    if(this.authService.isLoggedIn == true)
    {
       this.is_authenticate_user = true;
    console.log(this.totalqty);
    if (this.slected_card != 0) {
      this.orderRequest = {
        shop_type: "Club Sponsorship",
        cartlist: this.clubSingle.club_sponsor_id,
        customer_id: this.cus_id,
        card_id: this.slected_card,
        quantity: jQuery("#quantity").val(),
        code: jQuery("#promo_code").val(),
        type: "Club Sponsorship",
      };
      this.request = Object.assign({}, this.orderRequest);

      this.authService
        .Checkout(this.request)
        .then((res) => {
          console.log(res.status);

          if (res.status == 0) {
            this.orderError = res.message;
          } else {
            this.orderbookinList = res.data;
            //console.log(res.data);
            console.log(this.orderbookinList);
            this.router.navigate(["/bookingconfirm"]);
          }
        })
        .catch((err) => {
          this.orderError = err.error.message;
        });
    } else {
      jQuery(alert("Please select cards to checkout"));
    }
  }else{
     this.router.navigate(['/singin']);
    }

  }

  change_or_add() {
    jQuery(".checkout-center-detail-address").removeClass("hide-form");
    jQuery(".checkout-center-detail-address").addClass("show-form");
  }
  card_or_add() {
    jQuery(".ashton-hero-top-payment-add-card-detail").removeClass("hide-form");
    jQuery(".ashton-hero-top-payment-add-card-detail").addClass("show-form");
  }
  edit_detail_popup(assignid: any) {
    this.assignRequest = {
      matchticket_assign_id: assignid,
      account_no: jQuery("#account_no-" + assignid).val(),
      first_name: jQuery("#first_name-" + assignid).val(),
      last_name: jQuery("#last_name-" + assignid).val(),
      birth_date: jQuery("#birth_date-" + assignid).val(),
    };
    jQuery.magnificPopup.open({
      type: "inline",
      mainClass: "mfp-fade",
      removalDelay: 160,
      preloader: false,
      items: {
        src: jQuery("#login-box-" + assignid),
      },
      fixedContentPos: false,
      callbacks: {
        open: function () {},
        close: function () {
          //console.log("close");
        },
        // e.t.c.
      },
    });
  }
}
